export const GET_Cart_LOADING = "Cart/get/laoding";
export const GET_Cart_SUCCESS = "Cart/get/success";
export const GET_Cart_ERROR = "Cart/get/error";

// add item  
export const ADD_Cart_LOADING = "Cart/add/laoding";
export const ADD_Cart_SUCCESS = "Cart/add/success";
export const ADD_Cart_ERROR = "Cart/add/error";

// update  
// export const UPDATE_Cart_LOADING = "Cart/update/laoding";
// export const UPDATE_Cart_SUCCESS = "Cart/update/success";
// export const UPDATE_CartS_ERROR = "Cart/update/error";

// REMOVE  
export const REMOVE_Cart_LOADING = "Cart/remove/laoding";
export const REMOVE_Cart_SUCCESS = "Cart/remove/success";
export const REMOVE_Cart_ERROR = "Cart/remove/error";